import AccountAdminContracts from "./AccountAdminContracts-container";

/**
 * Export the top level component AccountAdminContracts-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default AccountAdminContracts;
